import { createVNode as _createVNode } from "vue";
import { IconWrapper } from '../runtime';
export default IconWrapper('align-text-left', true, function (props) {
  return _createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48"
  }, [_createVNode("g", {
    "stroke": "none",
    "stroke-width": props.strokeWidth,
    "fill": "none",
    "fill-rule": "evenodd",
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, [_createVNode("g", {
    "transform": "translate(6.000000, 8.000000)",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth
  }, [_createVNode("path", {
    "d": "M36,1 L3.55271368e-15,1"
  }, null), _createVNode("path", {
    "d": "M28,11 L5.32907052e-15,11"
  }, null), _createVNode("path", {
    "d": "M36,21 L0,21"
  }, null), _createVNode("path", {
    "d": "M28,31 L5.32907052e-15,31"
  }, null)])])]);
});